import { configureStore, ReducersMapObject } from "@reduxjs/toolkit";
import { Reducer } from "redux";

import { authReducer } from "@/entities/Auth";
import { subscriptionReducer } from "@/entities/Subscription";
import { api } from "@/shared/api/api";
import { rtkApi } from "@/shared/api/rtkApi";

import { createReducerManager } from "../lib/createReducerManager";
import { StateSchema, ThunkExtraArg } from "./StateSchema";

export function createReduxStore(initialState?: StateSchema, asyncReducers?: ReducersMapObject<StateSchema>) {
  const rootReducers: ReducersMapObject<StateSchema> = {
    ...asyncReducers,
    auth: authReducer,
    subscription: subscriptionReducer,
    [rtkApi.reducerPath]: rtkApi.reducer,
  };

  const reducerManager = createReducerManager(rootReducers);

  const extraArg: ThunkExtraArg = {
    api,
  };

  const store = configureStore({
    reducer: reducerManager.reduce as Reducer<StateSchema>,
    devTools: __IS_DEV__,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: extraArg,
        },
      }).concat(rtkApi.middleware),
  });

  // @ts-expect-error fix later
  store.reducerManager = reducerManager;

  return store;
}

export type AppDispatch = ReturnType<typeof createReduxStore>["dispatch"];
